import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingNanoBananaAiImageGeneratorConfig } from '@/data/landingConfig/landingNanoBananaAiImageGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_NanoBananaAiImageGenerator } from './schemaObject';

interface Props {}
const NanoBananaAiImageGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_NanoBananaAiImageGenerator} />
			<LandingTemplate
				data={landingNanoBananaAiImageGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default NanoBananaAiImageGenerator;
